import qcAtkCityIdsStore from "../store/qcAtkCityIds";


const useQcAtkCityIds = (playerId) => {
    const atkCityIds = qcAtkCityIdsStore((state) => state.cityIds);
    const setAtkCityId = qcAtkCityIdsStore((state) => state.setCityId);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        playerAtkCityIds: playerId == null ? [] : atkCityIds[playerId] ?? [],
        atkCityIds,
        setAtkCityId
    };
};

export default useQcAtkCityIds;
